import React, { useLayoutEffect, useState } from "react"
import { Row, Col, Container } from "react-bootstrap"

import { JobListingsContainer } from "../../../styles/Components/SingleInstance/JobListings"
import Heading from "../../../utils/OptimizedHeading"
import Breadcrumbs from "../../Breadcrumbs/BreadcrumbsV2"

import DisplayFilters from "./DisplayFilters"
import DisplayJobs from "./DisplayJobs"

const GREENHOUSE_JOBS_URL =
  "https://boards-api.greenhouse.io/v1/boards/clickatell18/jobs?content=true"

const JobListings = ({ component }) => {
  const [jobs, setJobs] = useState()

  const [filters, setFilters] = useState({
    selectedDepartments: [],
    selectedCountries: [],
    searchField: "",
  })

  const [departments, setDepartments] = useState([{ label: "", value: "" }])

  const [countries, setCountries] = useState([{ label: "", value: "" }])

  const [jobsByDept, setJobsByDept] = useState([])

  const [currentJobs, setCurrentJobs] = useState([])

  const [loading, setLoading] = useState(true)

  const formatJobs = (job) => {
    const jobObj = {
      country: job?.offices[0]?.location,
      department: job?.departments[0]?.name,
      ...job,
    }

    return jobObj
  }

  const createCountries = (formattedJobs) => {
    const allCountries = []
    formattedJobs.map((job) => {
      allCountries.push([job?.country])
    })
    const singleDimensionArr = [].concat(...allCountries)
    return [...new Set(singleDimensionArr)]
  }

  const fetchJobs = async () => {
    try {
      const response = await fetch(GREENHOUSE_JOBS_URL)
      const processedResponse = await response.json()
      const listOfJobs = processedResponse?.jobs
      const formattedJobs = []
      listOfJobs.forEach((job) => {
        const formattedJob = formatJobs(job)
        formattedJobs.push(formattedJob)
      })
      setJobs(formattedJobs)
      setCountries(createCountries(formattedJobs))
      setDepartments(
        [...new Set(formattedJobs.map((job) => job?.department))].sort()
      )
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
    }
  }

  useLayoutEffect(() => {
    fetchJobs()
  }, [])

  useLayoutEffect(() => {
    const sortJobsByDept = jobs?.reduce((deptsWithJobs, job) => {
      const department = job.department
      if (deptsWithJobs[department] == null) {
        deptsWithJobs[department] = []
      }
      deptsWithJobs[department].push(job)
      return deptsWithJobs
    }, {})
    setJobsByDept(sortJobsByDept)
  }, [jobs])

  useLayoutEffect(() => {
    jobsByDept ? setCurrentJobs(jobsByDept) : null
  }, [jobsByDept])

  return (
    <JobListingsContainer>
      <Container fluid>
        <Row>
          <Col className="blue" xl>
            <Container className="left">
              <Breadcrumbs
                data={[
                  { link: "/jobs", label: "Careers" },
                  { link: "#", label: "Jobs Listing", strong: true },
                ]}
              />
              {component?.eyebrow && (
                <p className="heading-kicker eyebrow">{component?.eyebrow}</p>
              )}
              {component?.heading && (
                <Heading
                  type={component?.headingSize}
                  string={component?.heading}
                  className="heading"
                />
              )}

              <DisplayFilters
                jobs={jobs}
                jobsByDept={jobsByDept}
                setCurrentJobs={setCurrentJobs}
                currentJobs={currentJobs}
                departments={departments}
                countries={countries}
                filters={filters}
                setFilters={setFilters}
              />
            </Container>
          </Col>
          <Col xl>
            <Container className="right">
              <DisplayJobs
                jobsByDept={jobsByDept}
                jobs={jobs}
                currentJobs={currentJobs}
                setCurrentJobs={setCurrentJobs}
                filters={filters}
                loading={loading}
                setLoading={setLoading}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </JobListingsContainer>
  )
}

export default JobListings
